// extracted by mini-css-extract-plugin
module.exports = {"link":"CardLink_link__3iN6r","link_sp":"CardLink_link_sp__1ETyO"};